<div class="order-confirmation-container">
  <div class="content container">
    <div class="top-section">
      <div class="icon-container">
        <mat-icon svgIcon="tick" class="tick-icon"></mat-icon>
        <mat-icon svgIcon="fullstar" class="star-icon"></mat-icon>
      </div>

      <p class="title font-poppins">
        Order Confirmed! 🎉
      </p>
      <p class="subtitle">
        Thank you for shopping with Funfigz. Your order has been placed
        successfully placed and is now being processed.
      </p>

      <p class="estimated-delivery">Estimated Delivery: 7-8 Business days</p>
    </div>

    @if (orderDetails) {
    <div class="bottom-section">
      <div class="bottom-left-section">
        <div class="order-details">
          <div class="left-section">
            <p class="order-details-title font-poppins">Order Details</p>
            <p class="order-date-contianer">
              <span>
                <span class="primary-color">#</span>
                Order ID: <span class="order-id">{{ orderDetails.id }}</span>
              </span>
              <span>
                <mat-icon [svgIcon]="'date'" class="date-icon"></mat-icon>
                <span class="order-date">{{
                  orderDetails.createdAt | date: "EE, dd MMMM y"
                }}</span>
              </span>
            </p>
          </div>

          <button mat-stroked-button class="view-order-btn" (click)="gotoOrder()">
            View & Manage Order
          </button>
        </div>

        <div class="delivery-address">
          <div class="icon-container">
            <mat-icon svgIcon="location" class="location-icon"></mat-icon>
          </div>

          <div>
            <p class="delivery-title font-poppins">Delivery Address</p>
            <p class="name">
              {{ orderDetails.orderAddress?.shippingAddress?.name }}
            </p>
            <p class="phone">
              {{ orderDetails.orderAddress?.shippingAddress?.mobileNumber }}
            </p>
            <p class="address">
              {{ orderDetails.orderAddress?.shippingAddress?.address }}
            </p>
            <p class="state">
              {{ orderDetails.orderAddress?.shippingAddress?.city }},
              {{ orderDetails.orderAddress?.shippingAddress?.state }},
              {{ orderDetails.orderAddress?.shippingAddress?.pincode }}
            </p>
          </div>
        </div>

        <div class="order-items">
          <p class="items-title font-poppins">Your Items</p>

          @for (item of getProducts();let i = $index; track i) {
          <div class="item">
            <div class="image-container">
              <img
                class="image"
                [class]="'product-image-gradient' + ((i % 3) + 1)"
                [src]="item.product?.images?.imagesUrl?.[0]"
                alt="Item Image"
              />
            </div>

            <div class="item-info">
              <div class="name-remove-container">
                <p class="item-name font-poppins" appEllipsis maxWidth="220px">
                  {{ item.product?.name }}
                </p>
                <div class="price-info">
                  @if (item.discountedPrice) {
                  <p class="discounted-price font-poppins">
                    {{ item.discountedPrice | currency: "INR" }}
                  </p>
                  <p class="price font-inter">
                    {{ item.price | currency: "INR" }}
                  </p>
                  } @else {
                  <p class="discounted-price font-poppins">
                    {{ item.price | currency: "INR" }}
                  </p>
                  }
                </div>
              </div>

              <p class="item-description">
                Color: MultiColor
              </p>
              <p>{{item.product?.modelQuantityJson?.totalBlock || 20}} Blocks Configuration</p>

              <p class="quantity">Quantity: {{ item.quantity }}</p>
              @if ( item.product?.category?.includes(categories.BuyBlocks) ) {
              <div
                class="block-item-info-container"
                *ngIf="item.product?.category?.includes(categories.BuyBlocks)"
              >
                <div class="node-hole-plane-config">
                  <div
                    *ngIf="getFacesByType(item, 'Plane').length > 0"
                    class="plane-config"
                  >
                    <span class="block-face-label"
                      >{{ "cart.shapeFacetype.plane" | translate }}:
                    </span>
                    <span class="block-face-value">{{
                      getFacesByType(item, "Plane").join(", ")
                    }}</span>
                  </div>

                  <div
                    *ngIf="getFacesByType(item, 'Hole').length > 0"
                    class="hole-config"
                  >
                    <span class="block-face-label"
                      >{{ "cart.shapeFacetype.hole" | translate }}:
                    </span>
                    <span class="block-face-value">{{
                      getFacesByType(item, "Hole").join(", ")
                    }}</span>
                  </div>

                  <div
                    *ngIf="getFacesByType(item, 'Node').length > 0"
                    class="node-config"
                  >
                    <span class="block-face-label"
                      >{{ "cart.shapeFacetype.node" | translate }}:
                    </span>
                    <span class="block-face-value">{{
                      getFacesByType(item, "Node").join(", ")
                    }}</span>
                  </div>
                </div>

                <div class="color-config">
                  <div class="color-title-section">
                    <mat-icon [svgIcon]="'color'" class="color-icon"></mat-icon>
                    <p class="color-title">Custom Color configuration</p>
                  </div>

                  <div class="color-info">
                    <div
                      *ngFor="
                        let color of getFaceColors(item.singleBlockInfoDirectBuy?.color)
                      "
                    >
                      <div class="color-item">
                        <div class="color-name">
                          <span
                            class="color-box"
                            [ngStyle]="{
                              'background-color': getColorValue(color.value)
                            }"
                          ></span>
                          <span class="block-face-label">{{ color.key }} </span>
                        </div>
                        <div class="block-face-value">
                          {{ color.value }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              }

              <div
                class="price-quantity-container"
                [ngClass]="{
                  'custom-color-container': item.product?.category?.includes(
                    categories.BuyBlocks
                  )
                }"
              >
              </div>
            </div>
          </div>
          }
        </div>
      </div>

      <div class="bottom-right-section">
        <div class="order-summary-section">
          <p class="title font-poppins">Order Summary</p>
          <div class="order-amount-section">
            <div class="section">
              <span class="label">Total MRP</span>
              <span class="value">{{
                orderDetails.currentSubTotal | currency: "INR"
              }}</span>
            </div>
            <div class="section">
              <span class="label">Coupon Discount</span>
              <span class="value discount">{{
                orderDetails.currentCouponDiscount | currency: "INR"
              }}</span>
            </div>

            <div class="section">
              <span class="label">Delivery Fee</span>
              <span class="value delivery">Free</span>
            </div>

            <div class="section">
              <span class="label">Coins Used</span>
              <span class="value">{{
                orderDetails.originalCoinsUsed | currency: "INR"
              }}</span>
            </div>

            <div class="separator"></div>

            <div class="section total-section font-poppins">
              <span class="total">Total Amount</span>
              <span class="total-value">{{
                orderDetails.currentPaymentAmount | currency: "INR"
              }}</span>
            </div>
          </div>

          <button
            mat-stroked-button
            class="continue-shopping-button font-poppins"
            (click)="gotoProducts()"
          >
            <mat-icon [svgIcon]="'cart'" class="cart-icon"></mat-icon>
            <span class="button-text">Continue Shopping</span>
          </button>

          <div class="secure-section">
            <span>Need Help?</span> 
            <a routerLink="/contact" class="contact">
              <span>Contact Support</span>
            </a>
          </div>
        </div>
      </div>
    </div>
    }
  </div>
</div>
